/**
 * The CPV screen surface: the light grey page with the kit's tokens applied as CSS variables. Pages put a PageHeader,
 * KPI cards and DataCards inside it; it adds nothing else.
 */
import React from 'react';
import { useCpvTokens } from './useCpvTokens';
import './cpv-ui.css';

export default function CpvScreen({ children, testId, className = '' }) {
  const { vars } = useCpvTokens();
  return (
    <div className={`cu-screen ${className}`} style={vars} data-testid={testId}>
      <div className="cu-stack">{children}</div>
    </div>
  );
}
